<template>
    <div class="custom-radio-item cpointer" :class="{ 'selected' : value == data.value}" @click="change">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
            }
        },
        methods: {
            change() {
                this.$emit('input', this.data.value)
            }
        }
    }
</script>
